module.exports = __webpack_public_path__ + "assets/img/thumb-Betashares-Explainer-Animation-Video.c2bb80ae.jpg";